import * as React from 'react';
import classnames from 'classnames';

import SVGIcon from 'components/svg-icon/SVGIcon';

import './video-player.scss';

interface Props {
  height: number,
  width: number,
  videoUrl: string,
  posterImgUrl?: string
}

const VideoPlayer = ({
  height,
  width,
  videoUrl,
  posterImgUrl
}: Props): JSX.Element => {
  const [showPlay, setShowPlay] = React.useState(true);
  const videoRef = React.createRef<HTMLVideoElement>();
  const togglePlay = () => {
    if (!videoRef.current) {
      return;
    }

    if (showPlay) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }

    setShowPlay(!showPlay);
  };

  return (
    <div className="video-player">
      <div className="video-player__video">
        <video
          key={videoUrl}
          height={height}
          width={width}
          ref={videoRef}
          poster={posterImgUrl}
          src={videoUrl}
          onEnded={() => setShowPlay(true)}
        >
          <track kind="captions" />
        </video>
        <div
          className="video-player__video-cover"
          onClick={togglePlay}
        >
          <SVGIcon
            name="play-button"
            width={40}
            height={40}
            className={classnames('video-player__poster-play-button', {
              'video-player__poster-play-button--hidden': !showPlay
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
